<script lang="ts">
	import TimeToCompleteIcon from '../Icon/timeToCompleteIcon.svelte';
	import SkillLevelIconHigh from '../Icon/skillLevelIconHigh.svelte';
	import SkillLevelIconMedium from '../Icon/skillLevelIconMedium.svelte';
	import SkillLevelIconLow from '../Icon/skillLevelIconLow.svelte';
	import PrerequisitesIcon from '../Icon/prerequisitesIcon.svelte';
	import CertificateIcon from '../Icon/certificateIcon.svelte';
	import type { EntryIcon } from './Entry';

	export let text: string | undefined = undefined;
	export let icon: EntryIcon;

	export let iconComponents: Partial<Record<EntryIcon, any>> = {
		certificate: CertificateIcon,
		prerequisite: PrerequisitesIcon,
		skillLevelAdvanced: SkillLevelIconHigh,
		skillLevelIntermediate: SkillLevelIconMedium,
		skillLevelBeginner: SkillLevelIconLow,
		timeToComplete: TimeToCompleteIcon
	};
</script>

<div class="flex flex-row items-center gap-2">
	<svelte:component this={iconComponents[icon]} />

	{#if text}
		<div class="text-xs">{text}</div>
	{/if}
</div>
